var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.1526L9 10.0509M10.3333 6.6329C10.3333 7.2613 10.2126 7.88356 9.97811 8.46413C9.74358 9.0447 9.39984 9.57222 8.9665 10.0166C8.53316 10.4609 8.01871 10.8134 7.45252 11.0539C6.88634 11.2944 6.2795 11.4181 5.66667 11.4181C5.05383 11.4181 4.447 11.2944 3.88081 11.0539C3.31462 10.8134 2.80018 10.4609 2.36683 10.0166C1.93349 9.57222 1.58975 9.0447 1.35523 8.46413C1.12071 7.88356 1 7.2613 1 6.6329C1 5.36377 1.49167 4.14663 2.36683 3.24922C3.242 2.35181 4.42899 1.84766 5.66667 1.84766C6.90434 1.84766 8.09133 2.35181 8.9665 3.24922C9.84167 4.14663 10.3333 5.36377 10.3333 6.6329Z",
    stroke: "#8C8E90",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconSearch);
export default __webpack_public_path__ + "static/media/common_icon_search.b85697d1aa9b8f64429ab4aad3d22aa0.svg";
export { ForwardRef as ReactComponent };